"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _headers = require("../../../services/fetch/headers");
var _config = _interopRequireDefault(require("../../../consts/config"));
var _handlers = require("../../../services/fetch/handlers");
const handleRegistrationResponse = json => {
  var _json$message;
  if (!("error_code" in json)) {
    return {
      success: true
    };
  }
  if (json.error_code === "INVALID_ARGUMENT_LOGIN" && (_json$message = json.message) !== null && _json$message !== void 0 && _json$message.includes("already exist")) {
    return {
      error: "ACCOUNT_EXISTS"
    };
  }
  switch (json.error_code) {
    case "INVALID_ARGUMENT_PASSWORD":
      return {
        error: "WEAK_PASSWORD"
      };
    case "INVALID_ARGUMENT_EMAIL":
      return {
        error: "INVALID_EMAIL"
      };
    default:
      return {
        error: "UNKNOWN"
      };
  }
};
const createAccount = _ref => {
  let {
    brandId,
    credentials,
    language
  } = _ref;
  const payload = {
    brand: brandId,
    email: credentials.email,
    password: credentials.password,
    login: credentials.email,
    // we use email as login
    first_name: "",
    // not used now on frontend
    last_name: "",
    // not used now on frontend
    properties: {
      language: {
        value: language !== null && language !== void 0 ? language : ""
      }
    }
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/user.save`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(_handlers.handleError).then(response => response.json()).then(handleRegistrationResponse);
};
var _default = exports.default = createAccount;